'use client';

import type { ComponentProps } from 'react';

import HeroSplit from '@dvd/modules/Heroes/HeroSplit';
import { useMacDownloadHref } from '@hooks/useMacDownloadHref';

type MacDownloadHeroSplitProps = ComponentProps<typeof HeroSplit>;

/**
 * HeroSplit whose secondary CTA is the Mac download, routed per device by
 * `useMacDownloadHref`.
 */
const MacDownloadHeroSplit = ({
  secondaryCta,
  ...props
}: MacDownloadHeroSplitProps) => {
  const href = useMacDownloadHref();
  return <HeroSplit {...props} secondaryCta={{ ...secondaryCta, href }} />;
};

export default MacDownloadHeroSplit;
